import { inject, Injectable } from '@angular/core';

import { createActionResponseFactory } from '@core/ngrx-legacy';
// eslint-disable-next-line boundaries/element-types
import { TellentMembersActions } from '@core/tellent-data'; // FIXME
import { TellentMembersDataFacade } from '@core/tellent-logic';

@Injectable()
export class EditMemberGroupsTabService {
  private readonly actionsResponse = createActionResponseFactory(TellentMembersActions);
  private readonly membersDataFacade = inject(TellentMembersDataFacade);

  public selectGroupDetailsData(guid: string) {
    return this.membersDataFacade.teamMemberById(guid);
  }

  public addMembersToGroup(memberGuid: string, groupsGuids: string[]) {
    return this.actionsResponse(TellentMembersActions.addGroups, {
      payload: { memberGuid, groupsGuids },
    });
  }

  public removeMembersFromGroup(memberGuid: string, groupsGuids: string[]) {
    return this.actionsResponse(TellentMembersActions.removeGroups, {
      payload: { memberGuid, groupsGuids },
    });
  }
}
